export const makeGraphQLVariable = (params: any, name = 'data') => {
  return { [name]: params }
}
